import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.0303 5.21967C15.7374 4.92678 15.2626 4.92678 14.9697 5.21967L8.71967 11.4697C8.42678 11.7626 8.42678 12.2374 8.71967 12.5303L14.9697 18.7803C15.2626 19.0732 15.7374 19.0732 16.0303 18.7803C16.3232 18.4874 16.3232 18.0126 16.0303 17.7197L10.3107 12L16.0303 6.28033C16.3232 5.98744 16.3232 5.51256 16.0303 5.21967Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgChevronLeft;
